import {
    Button,
    Checkbox, Grid, Paper, Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getSequencing, updateSequencingQc } from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            textAlign: "left",
            color: theme.palette.text.secondary,
        },
        center: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        disabled: {},
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
            padding: "5px",
            textTransform: "capitalize",
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);

interface SampleTransferProps {
    getSequencing: any;
    fetchRunSequencing: any;
    updateSequencingQc: any;
}

const SampleRegistrationTATMaster: React.FC<SampleTransferProps> = ({
    getSequencing,
    fetchRunSequencing,
    updateSequencingQc,

}) => {
    const classes = useStyles();
    const timer = useRef<any>(0);
    const [qcData, setQCData] = useState<any>([]);
    const { id } = useParams<{ id: string }>();
    const history = useHistory();
    useEffect(() => {
        const storeData: any = [];
        fetchRunSequencing?.libraries?.map((sequencing: any) => {
            storeData.push({
                id: sequencing?._id,
                runId: fetchRunSequencing.runId,
                flowCellType: sequencing?.flowCellType,
                lane: sequencing?.lane,
                projectId: sequencing?.projectId,
                sampleName: sequencing?.sampleName,
                libraryId: sequencing?.libraryId,
                type: sequencing?.type,
                indexType: sequencing?.indexType,
                firstIndex: sequencing?.firstIndex,
                firstSeq: sequencing?.firstSeq,
                secondIndex: sequencing?.secondIndex,
                secondSeq: sequencing?.secondSeq,
                chemistry: sequencing?.chemistry,
                averageBase: sequencing?.averageBase,
                dataSizeExpected: sequencing?.dataSizeExpected,
                isDataMessed: sequencing?.qcDone,
                isRelibrary: sequencing?.reLibrary,
            })
        });
        setQCData(storeData);

    }, [fetchRunSequencing])
    const updateItemValue = (
        key: string,
        value: any,
        item: any
    ) => {
        let tempTable = [...qcData];
        let newItem = item;
        switch (key) {
            case "is-data-messed":
                newItem.isDataMessed = value;
                break;
            case "is-relibrary":
                newItem.isRelibrary = value;
                break;
        }
        console.log("newItem", newItem);
        setQCData(tempTable);
    };
    const handleRunDataQc = async (e: any) => {
        e.preventDefault();
        const storeQcData: any = [];
        qcData && qcData?.length > 0 && qcData?.map((list: any) => {
            if (list?.isRelibrary) {
                storeQcData.push({
                    _id: list?.id,
                    reLibrary: "true",
                })
            } else if (list?.isDataMessed) {
                storeQcData.push({
                    _id: list?.id,
                    dataMatched: "true",
                })
            }

        })
        const sequenceDataQc = {
            libraries: storeQcData,
        };
        await updateSequencingQc(sequenceDataQc, id);
        history.push(`/dashboard/gnrelab/dataqc`);
    };
    useEffect(() => {
        getSequencing(id);
    }, [])
    
    return (
        <div style={{ width: "100%" }}>
            <Grid container spacing={3} style={{ margin: "25px auto" }}>
                <h2 style={{ fontWeight: "bold", paddingBottom: "10px", textAlign: "center", marginTop: 30 }}>Run Data QC</h2>
                <Grid container xs={12} style={{ padding: "15px 0" }}>
                    <TableContainer
                        className={classes.tableContainer}
                        component={Paper}
                        style={{ maxHeight: "540px", marginTop: 5 }}
                    >
                        <Table stickyHeader aria-label="simple table">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="center">Run ID</StyledTableCell>
                                    <StyledTableCell align="center">Flow Cell</StyledTableCell>
                                    <StyledTableCell align="center">Lane ID</StyledTableCell>
                                    <StyledTableCell align="center">Project Id</StyledTableCell>
                                    <StyledTableCell align="center">Sample Name</StyledTableCell>
                                    <StyledTableCell align="center">Lib Id</StyledTableCell>
                                    <StyledTableCell align="center">Lib Type</StyledTableCell>
                                    <StyledTableCell align="center">Index Type</StyledTableCell>
                                    <StyledTableCell align="center">First Index</StyledTableCell>
                                    <StyledTableCell align="center">First Seq</StyledTableCell>
                                    <StyledTableCell align="center">Second Index</StyledTableCell>
                                    <StyledTableCell align="center">Second Seq</StyledTableCell>
                                    {/* <StyledTableCell align="center">Chemistry</StyledTableCell> */}
                                    <StyledTableCell align="center">Average Base</StyledTableCell>
                                    <StyledTableCell align="center">Expected Data</StyledTableCell>
                                    <StyledTableCell align="center">Data Full</StyledTableCell>
                                    <StyledTableCell align="center">Relibrary Prep.</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            {qcData && qcData?.map((list: any, index: any) => (
                                <TableBody>
                                    <StyledTableRow >
                                        <StyledTableCell align="center">
                                            {list?.runId}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.flowCellType}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.lane}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.projectId}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.sampleName}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.libraryId}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.type}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.indexType}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.firstIndex}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.firstSeq}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.secondIndex}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.secondSeq}
                                        </StyledTableCell>
                                        {/* <StyledTableCell align="center">
                                            {list?.chemistry}
                                        </StyledTableCell> */}
                                        <StyledTableCell align="center">
                                            {list?.averageBase}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {list?.dataSizeExpected}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <Checkbox
                                            disabled={list?.isRelibrary}
                                                checked={list?.isDataMessed}
                                                onChange={(e) =>
                                                    updateItemValue(
                                                        "is-data-messed",
                                                        e.target.checked,
                                                        list
                                                    )
                                                }
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <Checkbox
                                            disabled={list?.isDataMessed}
                                                checked={list?.isRelibrary}
                                                onChange={(e) =>
                                                    updateItemValue(
                                                        "is-relibrary",
                                                        e.target.checked,
                                                        list
                                                    )
                                                }
                                            />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            ))}
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid container style={{}}>
                    <Button
                        color="secondary"
                        variant="contained"
                        style={{ width: 200, height: 46, marginTop: -5 }}
                        onClick={handleRunDataQc}
                    >
                        Update
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    fetchRunSequencing: state.GenomicsLabReducer.fetchRunSequencing,
});

export default connect(mapStateToProps, {
    getSequencing,
    updateSequencingQc,

})(SampleRegistrationTATMaster);
